import Navigation from '@/components/Navigation';
import Hero from '@/components/Hero';
// import SmartSearchSection from '@/components/SmartSearchSection';
import WhatWeDo from '@/components/WhatWeDo';
import WhyBuyFromUs from '@/components/WhyBuyFromUs';
import FAQSection from '@/components/FAQSection';
import Categories from '@/components/Categories';
import FeaturedListings from '@/components/FeaturedListings';
import GroupBuyProductsSection from '@/components/GroupBuyProductsSection';
import LiquidationProductsSection from '@/components/LiquidationProductsSection';
import { SaleTypesExplanation } from '@/components/SaleTypesExplanation';
import Footer from '@/components/Footer';
import { SecurityHeaders } from '@/components/SecurityHeaders';

const Index = () => {
  return (
    <div className="min-h-screen bg-background">
      <SecurityHeaders />
      <Navigation />
      <main>
        <Hero />
        <WhatWeDo />
        <SaleTypesExplanation />
        {/* <SmartSearchSection /> */}
        <Categories />
        <FeaturedListings />
        <GroupBuyProductsSection />
        <LiquidationProductsSection />
        <WhyBuyFromUs />
        <FAQSection />
      </main>
      <Footer />
    </div>
  );
};

export default Index;